import React, { useEffect, useState } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import Navbar from "./Components/Navbar.js";
import HomePage from "./Components/Homepage.js";
import CreditCardsPage from "./Components/CreditCardsPage.js";
import BankingProductsScreen from "./Components/BankingProductsScreen.js";

import TermsAndConditions from "./Components/TermsAndConditions.js";
import GrievanceRedressalPolicy from "./Components/GrievanceRedressalPolicy.js";
import RefundCancellationPolicy from "./Components/RefundCancellationPolicy.js";
import FAQPage from "./Components/FAQPage.js";
import PrivacyPolicy from "./Components/PrivacyPolicy.js";
import AboutUs from "./Components/AboutUs.js";
import ContactUs from "./Components/ContactUs.js";
import Features from "./Components/Features.js";


const theme = createTheme({
  palette: {
    primary: {
      main: "#117aae", // Main buttons, active states
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#ebf6f5", // Backgrounds, sections
    },
    tertiary: {
      main: "#fbe3e8", // Accent, soft highlights
    },
    background: {
      // default: "#ebf6f5",
      // paper: "#ffffff",
      default: "#fff"
    },
    text: {
      primary: "#0f2854",
      secondary: "#42526e",
    },
    typography: {
      fontFamily: "Poppins, sans-serif",
    },


  },
});


function App() {


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <HashRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/products" element={<BankingProductsScreen />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/Contactus" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/faq" element={< FAQPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/faq-page" element={<FAQPage />} />
          <Route path="/credit-cards/:id" element={<CreditCardsPage />} />
          <Route path="/grievance-redressal-policy" element={<GrievanceRedressalPolicy />} />
          <Route path="/refund-policy" element={<RefundCancellationPolicy />} />
          <Route path="/features" element={<Features />} />
        </Routes>
      </HashRouter>
    </ThemeProvider>
  );
}

export default App;